export default __webpack_public_path__ + "static/media/pico_logo_small_size.b7460602.png";